import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=25009a09&scoped=true&"
import script from "./MainFrame.vue?vue&type=script&lang=js&"
export * from "./MainFrame.vue?vue&type=script&lang=js&"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=25009a09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25009a09",
  null
  
)

export default component.exports